import { render, staticRenderFns } from "./PracticeCreate.vue?vue&type=template&id=57b5b2cb&scoped=true&"
import script from "./PracticeCreate.vue?vue&type=script&lang=js&"
export * from "./PracticeCreate.vue?vue&type=script&lang=js&"
import style0 from "./PracticeCreate.vue?vue&type=style&index=0&id=57b5b2cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b5b2cb",
  null
  
)

export default component.exports